import {useState} from 'react'
import {Link} from 'react-router-dom'
import {requestPassword} from '../core/_requests'
import './PasswordRecovery.css'

export const recoveryMessage = 'Si el correo está registrado en ALTREGO, recibirás un mensaje con las instrucciones para restablecer tu contraseña.'

export function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [sending, setSending] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  const submit = async (event: React.FormEvent) => {
    event.preventDefault()
    if (sending) return
    const normalized = email.trim().toLowerCase()
    setEmail(normalized)
    if (!normalized || normalized.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized)) {
      setError('Ingresa un correo electrónico válido.')
      return
    }
    setError('')
    setSending(true)
    try {
      await requestPassword(normalized)
      setSent(true)
    } catch {
      setError('No fue posible enviar la solicitud. Inténtalo nuevamente.')
    } finally {
      setSending(false)
    }
  }

  return <div className='password-recovery'>
    <div className='text-center mb-10'>
      <h1 className='text-dark mb-3'>Recuperar contraseña</h1>
      <p className='text-gray-400 fw-bold fs-6'>Ingresa el correo electrónico asociado a tu cuenta. Te enviaremos un enlace con las instrucciones para restablecer tu contraseña.</p>
    </div>
    {sent ? <div className='alert alert-success' role='status'>{recoveryMessage}</div> : <form className='form w-100' onSubmit={submit} noValidate>
      <div className='fv-row mb-10'>
        <label htmlFor='recovery-email' className='form-label fs-6 fw-bolder text-dark'>Correo electrónico</label>
        <input id='recovery-email' name='email' type='email' autoComplete='email' required maxLength={254} className='form-control form-control-lg form-control-solid' value={email} onChange={(e) => setEmail(e.target.value)} aria-invalid={Boolean(error)} aria-describedby={error ? 'recovery-error' : undefined} disabled={sending} />
      </div>
      {error && <div id='recovery-error' className='alert alert-danger' role='alert'>{error}</div>}
      <button type='submit' className='btn btn-lg btn-primary w-100 mb-5' disabled={sending}>{sending ? 'Enviando...' : 'Enviar instrucciones'}</button>
    </form>}
    <div className='text-center mt-5'><Link to='/auth' className='link-primary fw-bolder'>Volver a iniciar sesión</Link></div>
  </div>
}
